import {format, getTime, formatDistanceToNow} from 'date-fns'
import {HDate} from '@hebcal/core'
import {getMonthName, getYearText} from './month'

// ----------------------------------------------------------------------

export function fDate(date: Date | string | number) {
  return format(new Date(date), 'dd MMMM yyyy')
}

export function fDateTime(date: Date | string | number) {
  return format(new Date(date), 'dd MMM yyyy p')
}

export function fTimestamp(date: Date | string | number) {
  return getTime(new Date(date))
}

export function fDateTimeSuffix(date: Date | string | number) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p')
}

export function fToNow(date: Date | string | number) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  })
}

export function formatDate(date?: Date): string {
  if (!date) {
    return ''
  }
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()

  return `${day}/${month}/${year}`
}

export function fformatDate(date?: Date | null) {
  if (date) return format(date, 'yyyy-MM-dd')
}

export function fformatTime(date?: Date | null) {
  if (date) return format(date, 'HH:mm:ss')
}

export function fTime(date?: string) {
  if (date) {
    const [hours, minutes, seconds] = date.split(':')
    const time = new Date()
    time.setHours(
      parseInt(hours, 10),
      parseInt(minutes, 10),
      parseInt(seconds, 10)
    )
    return time
  }
}

// Returns 'ט"ו תשרי תשפ"ה' for a Gregorian Date (for side-by-side display with fDate).
export function fHebrewDate(date?: Date | string | null): string {
  if (!date) return ''
  const d = typeof date === 'string' ? new Date(date) : date
  const hd = new HDate(d)
  const dayGimatria = dayToHebrew(hd.getDate())
  const month = hd.getMonth()
  const year = hd.getFullYear()
  return `${dayGimatria} ${getMonthName(month, year)} ${getYearText(year)}`
}

const HEBREW_DAY_NAMES: Record<number, string> = {
  1: "א'", 2: "ב'", 3: "ג'", 4: "ד'", 5: "ה'", 6: "ו'", 7: "ז'", 8: "ח'", 9: "ט'",
  10: "י'", 11: 'י"א', 12: 'י"ב', 13: 'י"ג', 14: 'י"ד', 15: 'ט"ו', 16: 'ט"ז',
  17: 'י"ז', 18: 'י"ח', 19: 'י"ט', 20: "כ'", 21: 'כ"א', 22: 'כ"ב', 23: 'כ"ג',
  24: 'כ"ד', 25: 'כ"ה', 26: 'כ"ו', 27: 'כ"ז', 28: 'כ"ח', 29: 'כ"ט', 30: "ל'"
}

function dayToHebrew(day: number): string {
  return HEBREW_DAY_NAMES[day] ?? String(day)
}
